export default [
  {
    label: 'OR',
    value: 'or',
  }, {
    label: 'AND',
    value: 'and',
  },
];
